<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.generalInfo}}</h4>
            <form @keyup.enter="onSubmit" class="text-left">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div class="px-4" style="margin-left: -4.5%">
                    <div class="row">
                        <div class="col-lg-12">
                            <TabModule :selectedTab="selectedTab" :tabs="tabs" @method="changeModule"/>
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.functionality"
                                   :inputKey="'label'"
                                   :name="titles.placeholderNameFunctionality"
                                   :validate="$v.functionality.label"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.detailsFunctionality"
                                   :inputKey="'details'"
                                   :name="titles.placeholderDetailsFunctionality"
                                   :validate="$v.functionality.details"
                                   @method="getValue"
                            />
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <CheckBox :inputKey="'hasValue'" :name="titles.hasValue"
                                      :validate="functionality.hasValue" @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <CheckBox :inputKey="'enabled'" :name="titles.active" :validate="enabled"
                                      @method="getValue"/>
                        </div>
                    </div>
                </div>
                <div class="px-4 text-right">
                    <button
                            :disabled="isLoading"
                            @click="onSubmit"
                            class="btn btn-standard-gradient px-5"
                            type="button"
                            v-if="isEditable"
                    >
                        <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                        {{name_btn}}
                    </button>
                    <modal-success @messageFromModal="closeModal" id="success-functionality"
                                   title="Fonctionnalité ajoutée avec succès"/>
                    <modal-success @messageFromModal="closeModal" id="success-edit-functionality"
                                   title="Fonctionnalité modifiée avec succès"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {
        addFunctionalityWithModule,
        updateFunctionalityWithModule
    } from '../../shared/services/functionality.service';
    import {
        minLength,
        required
    } from 'vuelidate/lib/validators';
    import ModalSuccess from '../../common/modal-success';
    import {titles} from '../../../utils/general/titles';
    import {name} from '../../../utils/general/routers.js';
    import {functionality} from '../../shared/models/functionality';
    import Input from '@/components/common/Input.vue';
    import {icons} from '../../../utils/general/icons';
    import CheckBox from '../../common/CheckBox';
    import TabModule from '../../shared/formInfo/TabModule';
    import {getAllModules} from '../../shared/services/module.service';
    import {module} from '@/components/shared/models/module';
    import {filterMixin} from '../../../utils/filterMixin';
    import {errorMixin} from '../../../utils/errorMixin';

    export default {
        name: 'InfosFunctionality',
        components: {ModalSuccess, TabModule, Input, CheckBox},
        data() {
            return {
                titles,
                icons,
                isLoading: false,
                errorMsg: '',
                functionality: functionality(),
                isEditable: true,
                name_btn: titles.add,
                title: titles.functionalityAddExpression,
                items: [],
                tabs: [],
                selectedTab: null,
                oldModule: Number,
                enabled: false
            };
        },
        created() {
            if (this.$route.params.functionalityItem) {
                this.$cookies.set('functionalityItem', this.$route.params.functionalityItem);
                this.$cookies.set('functionalityItemIsEditable', this.$route.params.isEditable);
            }
            if (this.$cookies.isKey('functionalityItem')) {
                this.functionality = this.$cookies.get('functionalityItem');
                this.isEditable = this.$cookies.get('functionalityItemIsEditable');
                this.oldModule = this.functionality.module.id;
                this.title = titles.functionalityEditExpression;
                this.name_btn = titles.update;
                this.enabled = this.functionality.enabled;
            }
            this.loadModules();
        },
        mixins: [filterMixin, errorMixin],
        methods: {
            async loadModules() {
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'enabled',
                    '1',
                    null
                );
                await getAllModules(
                    1000, 1, null, this.filterQuery
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.items = this.items.map(item => {
                        this.tabs.push({
                            name: item.label,
                            item
                        });
                        return module(item);
                    });
                    this.selectedTab = this.tabs[0];
                    if (this.$route.params.functionalityItem) {
                        const module = this.items.find(item => item.id === this.$route.params.idModule);
                        this.selectedTab = {
                            name: module.label,
                            item: module
                        };
                    }
                });
            },
            changeModule(val) {
                this.functionality.module = val;
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.errorMsg = null;
                this.isLoading = true;


                if (this.$cookies.isKey('functionalityItem') === false) {
                    delete this.functionality.id;
                    this.functionality.module = this.functionality.module.id;
                    addFunctionalityWithModule(this.functionality).then(
                        response => {
                            this.functionality.id = response.data.id;
                            this.$emit('getFunctionality', this.functionality);
                            this.$bvModal.show('success-functionality');
                            this.isLoading = false;
                            return response;
                        },
                        error => {
                            this.showError(error);
                        }
                    );
                } else {
                    const id = this.functionality.id;
                    delete this.functionality.id;
                    this.functionality.module = this.functionality.module.id;
                    updateFunctionalityWithModule(id, this.functionality).then(
                        response => {
                            this.functionality.id = response.data.id;
                            this.$emit('getFunctionality', this.functionality);
                            this.$bvModal.show('success-edit-functionality');
                            this.isLoading = false;
                            return response;
                        },
                        error => {
                            this.showError(error);
                        }
                    );
                }
            },
            closeModal() {
                this.$cookies.remove('functionalityItem');
                this.$cookies.remove('functionalityItemIsEditable');
                this.$router.push({name: name.functionalityList});
            },
            getValue(inputKey, val) {
                this.$v.functionality[inputKey].$touch();
                this.functionality[inputKey] = val;
            }
        },
        validations: {
            functionality: {
                label: {
                    required,
                    minLength: minLength(3)
                },
                details: {
                    required
                },
                hasValue: {},
                module: {
                    required,
                    id: {required}
                },
                enabled: {
                    required
                }
            }
        }
    };
</script>

<style scoped>

</style>
